import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d369f3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { id: "list-content" }
const _hoisted_3 = { class: "image-wr" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }

import getImage from '@/tools/getImage';
    import getProductImage from '@/tools/getProductImage';
    import { ref, computed} from 'vue'
    import type { ComputedRef } from 'vue';
    import { useStore } from 'vuex';

    type ProductType = {
        id:number,
        name:string,
        categories:Array<string>,
        rating?:number,
        short_description:string
    }
    
    
export default /*#__PURE__*/_defineComponent({
  __name: 'ProductList',
  setup(__props) {

    const store = useStore()

    let products :ComputedRef<Array<ProductType>> = computed(() => {
        return store.getters.products
    })


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_unref(products).length > 0 && _unref(products) != undefined)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(_unref(products)[0].categories[0].toUpperCase()), 1),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(products), (product, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list-elem",
              key: index
            }, [
              _createVNode(_component_RouterLink, {
                class: "product-link",
                to: {name: 'product', params: {id: product.id, name: product.name}}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_3, [
                    _createElementVNode("img", {
                      src: _unref(getProductImage)(`${product.id}_400x400.webp`)
                    }, null, 8, _hoisted_4)
                  ]),
                  _createElementVNode("h3", null, _toDisplayString(product.name.toUpperCase()), 1),
                  _createElementVNode("p", null, _toDisplayString(product.short_description.toLowerCase()), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])
      ]))
    : (_openBlock(), _createElementBlock("section", _hoisted_5, " Категория пуста. Возможно что-то появится... "))
}
}

})